const docsUrls = {
  aboutNativeTLS:
    "https://maas.io/docs/how-to-enhance-maas-security#p-9102-configure-tls-33",
  addMachines:
    "https://maas.io/docs/how-to-manage-machines#p-9078-add-configure-machines",
  addNodesViaChassis: "https://maas.io/docs/how-to-manage-machines",
  autoRenewTLSCert:
    "https://maas.io/docs/how-to-enhance-maas-security#p-9102-renew-certificates",
  cloudInit: "https://maas.io/docs/how-to-use-cloud-init-with-maas",
  configurationJourney:
    "https://maas.io/docs/how-to-get-maas-up-and-running#p-9034-maas-ui-setup",
  dhcp: "https://maas.io/docs/about-maas-networking#p-20679-dhcp",
  hardwareSync:
    "https://maas.io/docs/how-to-manage-machines#p-9078-enable-hardware-sync-maas-32",
  ipmi: "https://maas.io/docs/reference-power-drivers#p-17434-ipmi",
  ipRanges:
    "https://maas.io/docs/about-maas-networking#p-20679-ip-range-management-and-static-ip-assignments",
  kvmIntroduction: "https://maas.io/docs/how-to-manage-machines#p-9078-add-vms",
  networkDiscovery:
    "https://maas.io/docs/about-maas-networking#p-20679-network-discovery",
  rackController:
    "https://maas.io/docs/about-controllers#p-13954-rack-controllers",
  sshKeys:
    "https://maas.io/docs/how-to-enhance-maas-security#p-9102-manage-users",
  tagsAutomatic: "https://maas.io/docs/about-machine-groups",
  tagsKernelOptions:
    "https://maas.io/docs/how-to-manage-machines#p-9078-set-kernel-parameters",
  tagsXpathExpressions: "https://www.w3schools.com/xml/XPath_intro.asp",
  vaultIntegration:
    "https://maas.io/docs/how-to-enhance-maas-security#p-9102-manage-vault",
  windowsImages:
    "https://maas.io/docs/how-to-build-custom-images#p-17423-build-windows-images",
} as const;

export default docsUrls;
